var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvatarLight = function SvgAvatarLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.92 25.305A14.85 14.85 0 0 0 30 15.045a15 15 0 0 0-30 0 14.79 14.79 0 0 0 4.08 10.26l.12.15a14.835 14.835 0 0 0 10.755 4.5 14.834 14.834 0 0 0 10.755-4.5l.12-.15h.09ZM15 1.545a13.5 13.5 0 0 1 13.5 13.5 13.38 13.38 0 0 1-3.165 8.67A15 15 0 0 0 15 19.545a15 15 0 0 0-10.335 4.17 13.38 13.38 0 0 1-3.165-8.67A13.5 13.5 0 0 1 15 1.545Zm-9.3 23.25a13.5 13.5 0 0 1 9.3-3.75 13.5 13.5 0 0 1 9.3 3.75 13.275 13.275 0 0 1-9.3 3.75 13.275 13.275 0 0 1-9.3-3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.045a6.405 6.405 0 0 0 6-6.75 6.405 6.405 0 0 0-6-6.75 6.405 6.405 0 0 0-6 6.75 6.405 6.405 0 0 0 6 6.75Zm0-12a4.935 4.935 0 0 1 4.5 5.25 4.935 4.935 0 0 1-4.5 5.25 4.936 4.936 0 0 1-4.5-5.25 4.935 4.935 0 0 1 4.5-5.25Z",
    fill: "currentColor"
  })));
};

export default SvgAvatarLight;